









































import { TicketParams } from '@/store/interfaces/tickets';
import DatesFormat from '@/util/classes/datesFormat';
import { status } from '@/util/transformString/translationsDecorator';
import Vue, { PropType } from 'vue';

const formatDate = new DatesFormat();

export default Vue.extend({
  name: 'DatesDescription',
  props: {
    ticket: {
      type: Object as PropType<TicketParams>,
      required: true,
    },
  },
  methods: {
    formatDate(date: string): string {
      return formatDate.formatDateTime(date);
    },
    statusTranslate(st: string): string {
      return status(st);
    },
  },
});
